import { useEffect, useState } from 'react';
import { loadClientTherapyHistory } from '../services/clientSessionStats';

export function useClientTherapyHistory(client, { enabled, teamId, therapistId, patients }) {
  const [record, setRecord] = useState(null);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let active = true;
    setRecord(null);
    if (!enabled || !teamId || !therapistId) return;
    const scope = { teamId, therapistId, patients };
    loadClientTherapyHistory(client, scope).then(
      history => { if (active) setRecord({ ...scope, history }); },
      () => { if (active) setRecord({ ...scope, error: true }); }
    );
    return () => { active = false; };
  }, [client, enabled, teamId, therapistId, patients, revision]);
  const current = enabled && record?.teamId === teamId
    && record?.therapistId === therapistId && record?.patients === patients ? record : null;
  return { history: current?.history, error: !!current?.error,
    loading: !!enabled && !!teamId && !!therapistId && !current,
    retry: () => setRevision(value => value + 1) };
}
